:host {
  --cms-iframe-aspect-ratio: 3 / 6;
  @include cms-components-host-defaults;
}

.host-inner {
  @include cms-default-grid-container;
}

.host-inner>* {
  grid-area: var(--cms-default-grid-area);
}

.iframe-node {
  aspect-ratio: var(--cms-iframe-aspect-ratio);
  width: 100%;
  height: 100%;
  border: 0;
}

@include media-width($breakpoint-sm) {
  .iframe-node {
    --cms-iframe-aspect-ratio: 4 / 3;
  }
}